import { props } from "skatejs";

export const skateJSErrorProps = {
  inError: { ...props.boolean, default: undefined },
  errorMessage: props.string,
};
